<template>
  <div class="hello">

    <b-container>
        <b-row style="">
            <b-col>
                <h2>Marketing Tools</h2>
            </b-col>
        </b-row>
        <hr style="height:2px;border-width:0;color:gray;background-color:gray">

        <transition name="fade">
            <div v-if="gettingBuyersList" class="loading">
                <p>Getting Buyers List..</p>
            </div>
        </transition>

        <!--Send marketing email -->
        <h5 style='color:#2e5189'>Market your products to buyers</h5>
        <b-row style="">
            <b-col>
                <b-button size="lg" variant="outline-primary"  tag="router-link" :to="{ path: '/campaign' }"><font-awesome-icon icon="bullhorn" /> Start A Marketing Campaign</b-button>
            </b-col>
        </b-row>
        <b-row style="margin-top:10px">
            <b-col><small>Campaign will reach all Keg Seeker buyers and any contacts you add from the link below</small></b-col>
        </b-row>
        <hr style="height:1px;border-width:0;color:#cccccc;background-color:#cccccc">

        <!------------------------------->
        <!---- Copy inventory HTML ------>
        <!------------------------------->
        <h5 style='color:#2e5189'>Copy your inventory as HTML to paste in your newsletters. HTML has live links for ordering.</h5>
        <b-button v-clipboard="getInventoryHTML" v-clipboard:success="clipboardSuccessHandler" id="inventoryhtml">
            <font-awesome-icon icon="copy"/> Copy Inventory as HTML
        </b-button>
        <!-- Preview ionventory HTML -->
        <b-button style="margin-left:5px" v-b-modal.modal-inventorypreview variant="outline-info">Show me what this looks like</b-button>
        <b-modal size='xl' id="modal-inventorypreview" ok-only>
            <div v-html="getInventoryHTML"></div>
        </b-modal>
        <hr style="height:1px;border-width:0;color:#cccccc;background-color:#cccccc">

        
        <!------------------------------->
        <!-- Collapse button for contacts --->
        <!------------------------------->
        <h5 style='color:#2e5189'>Marketing Contacts</h5>
        <b-row>
            <b-col>
                <div style='margin-top:10px; margin-bottom:10px;'>
                    <b-button v-b-toggle="'collapse-contacts'" size="lg" variant="outline-success" type="button"> 
                        <font-awesome-icon icon="user-friends" /> Manage Contacts <font-awesome-icon icon="caret-down" />
                    </b-button>
                </div>
            </b-col>
        </b-row>
        
        <!----------------------------->
        <!-- Contacts Collapse -->
        <!----------------------------->
        <b-row>
            <b-col>
                <b-collapse id='collapse-contacts'>
                    <b-card>
                        <Contacts />
                    </b-card>
                </b-collapse>
            </b-col>
        </b-row>
        <h6>Upload from CSV file or manually add emails</h6>
        <hr style="height:1px;border-width:0;color:#cccccc;background-color:#cccccc">

    <!-- Show all buyers list -->
    <b-row style="margin-top:20px">
        <b-col>
            <h5 style='color:#2e5189'>All Buyers on Keg Seeker</h5>
        </b-col>
    </b-row>
    <b-row style="">
        <b-col>
            <b-button size="lg" variant="outline-info" @click="getBuyers()"><font-awesome-icon icon="credit-card" /> Show me all the buyers</b-button>
        </b-col>
    </b-row>
    

    <!------------------------------>
    <!-- Modal to show all buyers -->
    <!------------------------------>
    <b-modal no-fade size="xl" id="buyers" title="All Buyers" 
        ok-title="OK" ok-only>
        <template v-for="buyer in buyersList">
            <b-row :key="buyer.uid + 'name'">
                <b-col>
                    {{buyer.company}}
                </b-col>
            </b-row>
            <b-row :key="buyer.uid + 'address'" style="color:grey">
                <b-col>
                    <small>{{buyer.address}}</small>
                </b-col>
            </b-row>
            <b-row :key="buyer.uid + 'message'" style="color:grey">
                <b-col>
                    <b-button v-b-modal="'SendMsg' + buyer.uid" v-b-tooltip.hover :title="'Message '+buyer.company" 
                        class='btn btn-primary action-buttons'>Send a Message
                    </b-button>
                </b-col>
            </b-row>
            <!---------------------------------------->
            <!-- Modal to send a message to a buyer -->
            <!---------------------------------------->
            <b-modal :id="'SendMsg' + buyer.uid" title="Send a Message"  hide-footer :key="buyer.uid + 'messagemodal'">
                <div class='col-12'>
                    <sendmessage  :receiverId="buyer.uid" :receiverName="buyer.company" :arrayDefaultMessages="arrayDefaultMessages"/>
                </div>
            </b-modal>
            <hr :key="buyer.uid + 'hr'">
        </template>
    </b-modal>
    <hr style="height:1px;border-width:0;color:#cccccc;background-color:#cccccc">

    <!---------------------------------------->
    <!---------- Public profile page --------->
    <!---------------------------------------->
    <b-row style="margin-top:20px">
        <b-col>
            <h5 style='color:#2e5189'>Share Your Public Profile Page with Inventory</h5>
        </b-col>
    </b-row>
    <b-row>
        <b-col>
            <b-button-group>
                <b-button v-clipboard="getBrewerURL" v-clipboard:success="clipboardSuccessHandler"  id="profilepage">
                    <font-awesome-icon icon="copy"/> Copy Link 
                </b-button>
                <b-button variant="primary" style="margin-left:10px">
                    <social-sharing :url="'https://kegseeker.com/#/brewers/' +userProfile.shortName"
                        title="Check out our inventory on Kegseeker.com"
                        description="See and order our latest beers on Kegseeker.com"
                        quote="Check out our inventory on Kegseeker.com"
                        inline-template>
                        <div>
                            <network network="facebook"   >
                                <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook' }"/> Share on Facebook
                            </network>
                        </div>
                    </social-sharing>
                </b-button>
            </b-button-group>
        </b-col>
    </b-row>
    <b-row style="margin-top:10px">
        <b-col>
            <small>Include link to your profile page in your email newsletters. Profile page is public</small>
        </b-col>
    </b-row>

    <!--Sales report -->
    <hr style="height:1px;border-width:0;color:#cccccc;background-color:#cccccc">
    <h5 style='color:#2e5189'>See your Keg Seeker sales report</h5>
    <b-row style="margin-bottom:50px">
        <b-col>
            <b-button size="lg" variant="outline-success" @click="goToSalesReport()"><font-awesome-icon icon="chart-line" /> Sales Report</b-button>
        </b-col>
    </b-row>
    <hr>

    </b-container>

  </div>
</template>

<script>

import { mapState } from 'vuex'
import Contacts from './Contacts'
const fb = require('../../firebaseConfig.js')
import Sendmessage from '../Sendmessage'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'userInventory']),
            getBrewerURL(){
                return 'https://kegseeker.com/#/brewers/'+this.userProfile.shortName
            },
            getInventoryHTML(){
                //Create main HTML body
                var brewerLink = "https://kegseeker.com/#/brewers/" + this.userProfile.shortName
                //Add brewery name
                var userHTML = ""
                var beerLink = ""
                var ksorderimage = "https://res.cloudinary.com/lo4xxr5lr/image/upload/v1603478783/icons/KS-order_button-blue.png"
                
                var inventoryTable = ''

                //Create the inventory table
                inventoryTable = inventoryTable + "<div><table style='margin-top:10px; border:none'>"
                for (var m=0; m<this.userInventory.length; m++){
                    //Add only if qty>0
                    var barrel1Quantity = 0; var barrel2Quantity = 0; var canQuantity = 0; var bottleQuantity = 0; 
                    if (this.userInventory[m].barrel1Quantity>0&&!isNaN(this.userInventory[m].barrel1Quantity)) barrel1Quantity = this.userInventory[m].barrel1Quantity
                    if (this.userInventory[m].barrel2Quantity>0&&!isNaN(this.userInventory[m].barrel2Quantity)) barrel2Quantity = this.userInventory[m].barrel2Quantity
                    if (this.userInventory[m].canQuantity>0&&!isNaN(this.userInventory[m].canQuantity)) canQuantity = this.userInventory[m].canQuantity
                    if (this.userInventory[m].bottleQuantity>0&&!isNaN(this.userInventory[m].bottleQuantity)) bottleQuantity = this.userInventory[m].bottleQuantity
                    
                    //Get available quantity for multisize
                    var beerAvalQuantity = 0
                    beerAvalQuantity = Math.max(barrel1Quantity, barrel2Quantity, canQuantity, bottleQuantity)

                    if(beerAvalQuantity>0)
                    {
                        beerLink = "https://kegseeker.com/#/brewers/" + this.userInventory[m].shortName + '/' + this.userInventory[m].id
                        inventoryTable = inventoryTable + "<tr>"
                        //Logo
                        inventoryTable = inventoryTable + '<td colspan="1">'
                        //Keg Seeker logo by default
                        var logoImage = 'https://res.cloudinary.com/lo4xxr5lr/image/upload/v1599083749/icons/KegSeeker_logo_small2.png'
                        if(this.userInventory[m].beerLogoURL) logoImage = this.userInventory[m].beerLogoURL
                        else if (this.userInventory[m].logoFileThumbnailURL) logoImage = this.userInventory[m].logoFileThumbnailURL

                        inventoryTable = inventoryTable +'<a href=' + brewerLink + ' target="_blank">' +  "<img src=" + logoImage +' height="64">'
                        inventoryTable = inventoryTable + '</a>'
                        inventoryTable = inventoryTable + "</td>"
                        //Name
                        inventoryTable = inventoryTable + '<td colspan="4">'
                        inventoryTable = inventoryTable + "<a href=" + beerLink +  " target='_blank' style='font-size:20px; text-decoration: none; color:black'>" + this.userInventory[m].beerName + "</a>"
                        inventoryTable = inventoryTable + "</td>"

                        //End this row
                        inventoryTable = inventoryTable + "</tr>"

                        //Description row
                        if(this.userInventory[m].description){
                            inventoryTable = inventoryTable + '<tr><td colspan="5">'
                            inventoryTable =inventoryTable + '<div style="color:#808080; font-size:12px">' + this.userInventory[m].description + '</div>'
                            inventoryTable = inventoryTable + "</td></tr>"
                        }

                        //Barrel 1
                        if(this.userInventory[m].barrel1Size&&this.userInventory[m].barrel1Quantity>0){
                            inventoryTable = inventoryTable + '<tr style="font-size:15px"><td colspan="5">'
                            inventoryTable = inventoryTable + this.userInventory[m].barrel1Size + ': $ ' + this.userInventory[m].barrel1Cost
                            inventoryTable = inventoryTable + '</td></tr>'

                        }
                        //Barrel 2
                        if(this.userInventory[m].barrel2Size&&this.userInventory[m].barrel2Quantity>0){
                            inventoryTable = inventoryTable + '<tr style="font-size:15px"><td colspan="5">'
                            inventoryTable = inventoryTable + this.userInventory[m].barrel2Size + ': $ ' + this.userInventory[m].barrel2Cost
                            inventoryTable = inventoryTable + '</td></tr>'

                        }
                        //Can
                        if(this.userInventory[m].cansPerCase&&this.userInventory[m].canQuantity>0){
                            inventoryTable = inventoryTable + '<tr style="font-size:15px"><td colspan="5">'
                            inventoryTable = inventoryTable + this.userInventory[m].ozPerCan + ' oz/can, ' +  this.userInventory[m].cansPerCase + ': $ ' + this.userInventory[m].canCost
                            inventoryTable = inventoryTable + '</td></tr>'

                        }
                        //Bottle
                        if(this.userInventory[m].bottlesPerCase&&this.userInventory[m].bottleQuantity>0){
                            inventoryTable = inventoryTable + '<tr style="font-size:15px"><td colspan="5">'
                            inventoryTable = inventoryTable + this.userInventory[m].ozPerBottle + ' oz/bottle, ' + this.userInventory[m].bottlesPerCase + ': $ ' + this.userInventory[m].bottleCost
                            inventoryTable = inventoryTable + '</td></tr>'

                        }
                        //Order Now Button
                        inventoryTable = inventoryTable + "<tr>"
                            inventoryTable = inventoryTable + "<td colspan='12'>"
                            inventoryTable = inventoryTable +'<a href=' + beerLink + ' target="_blank">' +  "<img src=" + ksorderimage +' height="30">'
                            inventoryTable = inventoryTable + '</a>'
                            inventoryTable = inventoryTable + "</td>"
                        inventoryTable = inventoryTable + "</tr>"

                        //Horizontal line
                        inventoryTable = inventoryTable + "<tr>"
                        inventoryTable = inventoryTable + '<td colspan="8">'
                        inventoryTable = inventoryTable + '<hr>'
                        inventoryTable = inventoryTable + '</td>'
                        inventoryTable = inventoryTable + "</tr>"
                        
                    }
                }
                inventoryTable = inventoryTable + "</table></div>"

                //Add table to main HTML
                userHTML = userHTML + inventoryTable

                return userHTML
            },
    },

    components: {
        Contacts,
        Sendmessage
    },

    data() {
        return {
            manualEmails:'',
            gettingBuyersList:false,
            buyersList:[],
            arrayDefaultMessages:[],
            includeInventory:true,

        }
    },

    methods:{
        addEmails(){
            const emailsArray = this.extractEmails(this.manualEmails)
            console.log("emailsArray=")
            console.log(emailsArray)

            //Check emails that already exist
            const existingEmails = this.userProfile.manualEmails
            var emailsToAdd = []
            if(this.userProfile.manualEmails) emailsToAdd = this.userProfile.manualEmails
            //Iterate over new emails
            for (var i=0; i<emailsArray.length; i++){
                const existingEmailIndex = emailsToAdd.findIndex(item => item === emailsArray[i])
                if(existingEmailIndex<0) emailsToAdd.push(emailsArray[i])
            }

            //Add to userProfile
            fb.usersCollection.doc(this.currentUser.uid).update({
                    manualEmails:emailsToAdd,
                })

            
        },

        extractEmails (text)
        {
            return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
        },

        //Go to compose email
        goToComposeEmail(){
            this.$router.push({name:'selectcountiesforemail'})
        },

        //Go to sales report
        goToSalesReport(){
            this.$router.push({name:'salesreport'})
        },

        //Get buyers list
        getBuyers(){
            this.gettingBuyersList=true
            this.buyersList = []
            var buyersArray=[]
            fb.usersCollection.where("county", "in", this.userProfile.counties).where("state", "==", this.userProfile.state).where("isbrewer", "==", 0).get().then(docs => {
                docs.forEach(doc => {
                    var theBuyerData = doc.data()
                    var theBuyerId = doc.id
                    var theBuyerName = theBuyerData.company
                    var theBuyerEmail = theBuyerData.email
                    var theBuyerUid = theBuyerData.uid
                    //Create address
                    var address = theBuyerData.street1
                    if (theBuyerData.street2) address = address + ", " + theBuyerData.street2
                    address = address + ", " + theBuyerData.city + ', ' + theBuyerData.state  + " "  + theBuyerData.zip 
                    var buyerObject = {
                        company: theBuyerName,
                        email: theBuyerEmail,
                        uid: theBuyerId,
                        selected:true,
                        address:address,
                    }
                    buyersArray.push(buyerObject)

                    })
                }).then(res => {
                    this.buyersList = buyersArray
                    this.gettingBuyersList=false
                    this.$bvModal.show("buyers")
                    })
                    .catch(err => {
                        console.log(err)
                        this.gettingBuyersList=false
                })
        },

        //Clipboard success
        clipboardSuccessHandler(){
            this.$bvToast.toast('Copied to clipboard', {
                    solid:true,
                    variant: 'success',
                    autoHideDelay: 5000,
                    appendToast: false
                    })
        },


    },

    mounted(){
    },
}
</script>

